// extracted by mini-css-extract-plugin
module.exports = {"header":"managers_header__3bQIx","content":"managers_content__1yNBM","table":"managers_table__1wp8Y"};